import './stats-leaders/reducer/types';
import './season-leaders/reducer/types';
import './last-round-highs/reducer/types';

/**
 * @typedef {object} StatsProState
 * @property {StatsLeadersState} statsLeaders
 * @property {object} glossary
 * @property {SeasonLeadersState} seasonLeaders
 * @property {LastRoundHighsState} lastRoundHighs
 */

/**
 * @typedef {'seasons'|'rounds'} StatsLeadersStatsType
 * @typedef {'round'|'season'} LastRoundHighsStatsType
 */